import { ApiError, apiFetch, apiFetchRequest, apiRequest, downloadRequest, getOpenApiClientBaseUrl } from "./api-transport";
import { App as AntdApp } from "antd";
import { formatMessage } from "@umijs/max";
import { useCallback } from "react";
import { getErrorMessage as getSharedErrorMessage } from "@airange/shared/error-utils";

export { ApiError, apiFetch, apiFetchRequest, apiRequest, downloadRequest, getOpenApiClientBaseUrl };

export function getErrorMessage(error: unknown, fallback = formatMessage({ id: "common.messages.requestFailed" })) {
  return getSharedErrorMessage(error, fallback);
}

export function isRetryableRequestError(error: unknown) {
  if (error instanceof ApiError) {
    return [408, 409, 425, 429, 500, 502, 503, 504].includes(error.status);
  }
  if (error instanceof Error) {
    const detail = error.message.trim().toLowerCase();
    return detail.includes("network") || detail.includes("timeout") || detail.includes("temporar");
  }
  return false;
}

export function useRequestErrorNotification() {
  const { message } = AntdApp.useApp();

  return useCallback(
    (error: unknown, fallback?: string) => {
      message.error(getErrorMessage(error, fallback));
    },
    [message],
  );
}
